import { dayjs } from "~/utils/dayjs";

export default function formatTimeSpan(start, end, type = "date", { forceYears = false } = {}) {
  const s = dayjs(start);
  const e = dayjs(end);
  const showYears = forceYears || s.year() !== e.year() || s.year() !== dayjs().year() || e.year() !== dayjs().year();

  const dateFormat = showYears ? "DD/MM/YYYY" : "DD/MM";
  const formatRange = (fmt) => `${s.format(fmt)}–${e.format(fmt)}`;
  const formatDateTime = (fmt) => `${s.format(fmt)} ${s.format("HH.mm")}–${e.format("HH.mm")}`;

  if (type === "time") return formatRange("HH.mm");

  if (type === "datetime") {
    return e.isSame(s, "day") ? formatDateTime(dateFormat) : formatRange(dateFormat + " HH.mm");
  }

  return formatRange(dateFormat);
}
